import { afterNextPaint } from '@helpers/after-next-paint';
import { useConversationUrl } from '@hooks/use-conversation-url';
import { useAppSelector } from '@redux/hooks';
import RfqModal from '@tkmp/rfq/components/RfqModal/RfqModal';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import { generateDefaultField } from '@tkmp/rfq/utils';
import { CtaButton } from '@tkww/orion-web-ds-action';
import { Body1 } from '@xo-union/tk-ui-typography';
import { useAtomValue } from 'jotai';
import React, { type FC } from 'react';
import { vendorAwardsAtom } from '../../jotai/storefront/awards-summary';
import Styles from './awards-banner.scss';

export interface AwardsBannerProps {
	className?: string;
}

export const AwardsBanner: FC<AwardsBannerProps> = ({ className }) => {
	const awards = useAtomValue(vendorAwardsAtom);
	const vendorId = useAppSelector((state) => state.vendor.vendor?.id);
	const conversationUrl = useConversationUrl(vendorId);

	const localFormContext = useInlineRfqForm({
		freeTextLabel: '',
		headerText:
			'Join couples who chose award-winning vendors for their wedding',
		textAreaInitialValueOverride: generateDefaultField('textarea'),
		initiator: 'Awards and Affiliations',
	});

	if (!awards || awards.length === 0) {
		return null;
	}

	return (
		<>
			{!conversationUrl && <RfqModal context={localFormContext} />}
			<div
				className={`${Styles.container}${className ? ` ${className}` : ''}`}
				data-testid="awards-cta-container"
			>
				<div className={Styles.content}>
					<Body1 bold>
						Join couples who chose award-winning vendors for their wedding
					</Body1>
					{conversationUrl ? (
						<CtaButton
							styleType="secondary"
							size="md"
							as="a"
							treatAs="link"
							href={conversationUrl}
							className={Styles.button}
						>
							View Conversation
						</CtaButton>
					) : (
						<CtaButton
							styleType="secondary"
							size="md"
							className={Styles.button}
							onClick={() => {
								afterNextPaint(() => {
									localFormContext.openModal();
								});
							}}
						>
							Message vendor
						</CtaButton>
					)}
				</div>
			</div>
		</>
	);
};
